







import { Component, Vue } from "vue-property-decorator";
import BackLink from "@/components/app/BackLink.vue";
import { GbRecoveryModel } from "@/extensions/models/auth/GbRecoveryModel";
import MapComponent from "@/components/app/MapComponent.vue";

@Component({
components: { MapComponent, BackLink }
})
export default class AtmPage extends Vue {
}
